export default "__VITE_ASSET__O6Q9$MWv__"